import { Button, Typography } from "@carrotfertility/carotene-core"
import React from "react"

export function NoAvailabilityPage({ onBackToHome }: { onBackToHome?: () => void }): JSX.Element {
  return (
    <>
      <Typography>This is the No availability page</Typography>
      <Button onClick={onBackToHome}>Back to home</Button>
    </>
  )
}
